// @flow
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import chunk from 'lodash.chunk';

type Props = {
  items: Array<any>,
  galleryIndex: number,
};

const useStyles = makeStyles((theme) => ({
  description: {
    padding: theme.spacing(12, 4),

    [theme.breakpoints.between('sm', 'lg')]: {
      paddingTop: theme.spacing(3),
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(9, 3),
      textAlign: 'center',
    },
  },
}));

const ServiceItemsDescriptions = ({ items = [], galleryIndex = 0 }: Props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [partitions, setPartitions] = React.useState(chunk(items, 3));
  const classes = useStyles();

  React.useEffect(() => {
    if (matches) {
      setPartitions(chunk(items, 1));
    }
  }, [matches]);

  return (
    <Grid container spacing={6} display="flex" justifyContent="center">
      {partitions[galleryIndex].map((item) => (
        <Grid key={item.id} item lg={4} xs={12}>
          <Box component="div" className={classes.description}>
            <Typography color="primary" variant="body1">
              <ReactMarkdown>{item.descripcion.descripcion}</ReactMarkdown>
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default ServiceItemsDescriptions;
